import React from 'react';

import { Link } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

import { useTippspielBranding } from '../hooks/useTippspielBranding';

import T12Footer from './T12Footer';
import { publicUrl } from '../utils/publicUrl';

const PublicShell = ({ children, narrow = false }) => {

  const { isAuthenticated } = useAuth();

  const { seasonLabel, projectName } = useTippspielBranding();



  return (

    <div className="page-bg page-bg-glow flex flex-col">

      <header className="app-header relative z-20">

        <div className="max-w-6xl mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-4">

          <Link to="/" className="flex items-center gap-3 group">

            <img

              src={publicUrl('/assets/t12_logo.svg')}

              alt="Logo"

              className="h-10 w-auto opacity-90 group-hover:opacity-100 transition-opacity"

            />

            <div>

              <div className="font-bold text-lg leading-tight tracking-tight">Tippspiel</div>

              <div className="text-[0.65rem] font-bold uppercase tracking-[0.14em] text-primary">

                Saison {seasonLabel}

                {projectName ? ` · ${projectName}` : ''}

              </div>

            </div>

          </Link>

          <div className="flex items-center gap-2">

            {isAuthenticated ? (

              <Link to="/uebersicht" className="btn-wacker btn-wacker--sm">

                Zum Dashboard

              </Link>

            ) : (

              <>

                <Link to="/login" className="btn-wacker-outline btn-wacker--sm">

                  Anmelden

                </Link>

                <Link to="/register" className="btn-wacker btn-wacker--sm">

                  Registrieren

                </Link>

              </>

            )}

          </div>

        </div>

      </header>

      <main className={`relative z-10 mx-auto px-4 py-8 md:py-12 flex-1 w-full ${narrow ? 'max-w-md' : 'max-w-6xl'}`}>

        {children}

      </main>

      <T12Footer />

    </div>

  );

};



export default PublicShell;


